import { track } from 'lib/analytics'
import {
  AppPromoCollaboratorModal,
  AppPromoStartBuildingModal,
} from 'shared/app-modal-wave'
import { ConfettiOverlayPrimer } from './ConfettiOverlayPrimer/ConfettiOverlayPrimer'
import Slide from '../Slide/Slide'

const InstallApp = ({
  actEx2bMobile,
  isInActEx1PrimerVariation,
  isCollaborator,
  ...props
}) => {
  const isInActEx2bMobileVariation =
    actEx2bMobile === 'variation1' || actEx2bMobile === 'variation2'

  const trackingAttributes = {
    eventLocation: track.EventLocation.ONBOARDING_MINUS_APP_DOWNLOAD,
    experimentName: actEx2bMobile ? 'act_ex2b_mobile' : null,
    experimentGroup: actEx2bMobile || null,
  }
  track.appDownloadInterstitialViewed(trackingAttributes)

  if (isInActEx1PrimerVariation) {
    return (
      <Slide>
        <ConfettiOverlayPrimer />
        <AppPromoStartBuildingModal
          isVisible
          showActEx1PrimerInterstitial={isInActEx1PrimerVariation}
          showMobileInterstitialExperiment={isInActEx2bMobileVariation}
          trackAttributes={trackingAttributes}
          {...props}
        />
      </Slide>
    )
  }

  return isCollaborator ? (
    <AppPromoCollaboratorModal isVisible {...props} />
  ) : (
    <AppPromoStartBuildingModal
      isVisible
      showActEx1PrimerInterstitial={isInActEx1PrimerVariation}
      showMobileInterstitialExperiment={isInActEx2bMobileVariation}
      trackAttributes={trackingAttributes}
      {...props}
    />
  )
}

export default InstallApp
